<!-- 会员服务 -->

<template>
  <div id="memberServ">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
      <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
  #memberServ {
    height: 100%;
  }
</style>